@if (broadcast) {
  <div class="card card-broadcast">
    <div class="row">
      <div class="col-12 col-sm-5 col-md-12 col-xl-auto mb-3 mb-sm-0 mb-md-3 mb-xl-0">
        <div
          class="card-background"
          [ngStyle]="{
            'background-image':
              'url(' + $safeNavigationMigration(broadcast.photo?.url1x) + '?w=300&h=300&m=2' + addWebp + ')',
          }"
        >
          @if (broadcast.label) {
            <div class="card-broadcast-label">
              {{ broadcast.label }}
            </div>
          }
        </div>
      </div>
      <div class="col-12 col-sm">
        <div class="card-broadcast-body d-flex flex-column">
          <div class="row m-0 flex-nowrap w-100">
            <div class="col p-0 align-self-center">
              <div class="card-title dot">
                <span>{{ broadcast.title }}</span>
              </div>
            </div>
            <div class="col-auto p-0">
              <div class="broadcast-type-icon ml-1">
                <img class="icon" [src]="'/assets/icons/' + getBroadcastIcon(broadcast) + '.svg'" />
              </div>
            </div>
          </div>
          <div class="row mb-auto">
            <div class="col-12">
              @if (broadcast.subtitle) {
                <div class="card-sub-title">
                  {{ broadcast.subtitle }}
                </div>
              }
              @if (description) {
                <div class="card-description mt-0">
                  <div [innerHTML]="description"></div>
                </div>
              }
            </div>
          </div>
          <div class="mt-auto w-100 text-right">
            <a class="btn btn-secondary" [routerLink]="['/actueel', broadcast.permalink]">
              @if (broadcast.type === 3) {
                {{ 'global.read_more' | transloco }}
              } @else {
                <img class="icon-play" [src]="'/assets/icons/icon-play.svg'" />
                {{ 'global.play' | transloco }}
              }
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
